import React from "react";
import "./blogs.styles.css";

const Blogs = () => {
  return (
    <div className="blogs-section">
      <h1>hello</h1>
    </div>
  );
};

export default Blogs;
